import React, { useState } from 'react';

// Map the app's country labels to ISO 3166-1 alpha-2 codes (for flag images).
const CODE = {
  USA: 'us', UK: 'gb', Canada: 'ca', Australia: 'au', Germany: 'de',
  France: 'fr', UAE: 'ae', Pakistan: 'pk', India: 'in',
  Netherlands: 'nl', Singapore: 'sg',
};

/**
 * Real flag image (works on every OS, unlike emoji flags which Windows
 * does not render). If the image can't load, or the country is unknown,
 * it degrades to a small code chip / globe instead of a broken icon.
 */
export default function Flag({ country, width = 20, style }) {
  const code = CODE[country];
  const [failed, setFailed] = useState(false);
  const height = Math.round(width * 0.75);

  if (!code) {
    return <span style={{ fontSize: width - 4, lineHeight: 1, ...style }}>🌐</span>;
  }
  if (failed) {
    return (
      <span style={{
        fontSize: 9, fontWeight: 700, letterSpacing: '.5px', color: 'var(--text2)',
        background: 'var(--bg4)', borderRadius: 3, padding: '1px 4px', ...style,
      }}>{code.toUpperCase()}</span>
    );
  }
  return (
    <img
      src={`https://flagcdn.com/${width}x${height}/${code}.png`}
      srcSet={`https://flagcdn.com/${width * 2}x${height * 2}/${code}.png 2x`}
      width={width}
      height={height}
      alt={country}
      title={country}
      loading="lazy"
      onError={() => setFailed(true)}
      style={{ borderRadius: 2, verticalAlign: 'middle', objectFit: 'cover', display: 'inline-block', ...style }}
    />
  );
}
